export const contactObj = {
	Tiktok: "https://www.tiktok.com/@cncprotolabs",
	Instagram: "https://www.instagram.com/cncprotolabs/",
	Youtube: "https://www.youtube.com/@jsprecisionofficial",
	Twitter: "https://x.com/tsunami14713",
	Pinterest: "https://www.pinterest.com/cncprotolabs/",
	FaceBook: "https://www.facebook.com/cncprotolabs/",
	Linkedin: "https://www.linkedin.com/company/cncprotolabs",
};

export const contactInfo = {
	email: "info@cncprotolabs.com",
	phone: "+86 189 2585 8912",
	// Skype: "luckywu1112",
	whatsapp: "+86 189 2585 8912",
	address: "102, Building 2, No.1, South Jizhi Road, Humen Town, Dongguan City",
	/** 东莞市虎门镇片区邮编，用于 JSON-LD PostalAddress.postalCode（富媒体/地址校验） */
	postalCode: "523930",
	name: "JS Hardware Tech Co., Ltd",
};
